import React from 'react';
import * as Sentry from "@sentry/react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Sentry — capture frontend errors. Skip in dev so console isn't noisy.
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://5371e894a20687c31a68677ca25c3192@o4511539665174528.ingest.de.sentry.io/4511539772588112",
    environment: window.location.hostname.includes("staging") ? "staging" : "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
